import { render, staticRenderFns } from "./ModalProjectEdit.vue?vue&type=template&id=e06238fe&scoped=true"
import script from "./ModalProjectEdit.vue?vue&type=script&lang=js"
export * from "./ModalProjectEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectEdit.vue?vue&type=style&index=0&id=e06238fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06238fe",
  null
  
)

export default component.exports